import React from 'react'
import { useTabStore } from "../providers/TabProvider";
import { TabKey } from '../tabs';
import { Button, makeStyles } from '@fluentui/react-components';
import { PromptFilled } from '@fluentui/react-icons';
import { useResultStore } from '../providers/ResultProvider';
import { object } from 'prop-types';


const useStyles = makeStyles({

    button: {
        fontSize: "10px",
        cursor: "pointer",
        whiteSpace: "nowrap",
        width: "100%",
        border: "2px solid transparent",
        borderRadius: "0px",
        transition: "background-color 0.3s ease",
        "&:hover": {
            borderBottom: "2px solid #0F6CBD",
            transition: "border-bottom 0.3s ease"
        },
        "&.active": {
            borderBottom: "2px solid #0F6CBD",
            transition: "border-bottom 0.3s ease",
            fontWeight: "bold",
        }
    },
    tab: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: "0px 15px",
    },
    icon: {
        color: "#FF4AC9",
    }

});


export function TabButton() {
    const { activeTab, setActiveTab } = useTabStore();
    const { deepScanData } = useResultStore();

    const handleClick = (tabKey: TabKey) => {
        setActiveTab(tabKey);
    };

    return (
        <>
            <div className={useStyles().tab}>
                <Button
                    icon={<PromptFilled className={useStyles().icon} />}
                    appearance="transparent"
                    onClick={() => {
                        handleClick("ai-insight-result");
                    }}
                    className={`${activeTab === "ai-insight-result" ? "active" : ""} ${useStyles().button} `}
                >
                    AI Insight Results
                </Button>
                <Button
                    disabled={Object.keys(deepScanData).length == 0}
                    appearance="transparent"
                    onClick={() => {
                        handleClick("deep-scan-result");
                    }}
                    className={`${activeTab === "deep-scan-result" ? "active" : ""} ${useStyles().button} `}
                >
                    Scan Results
                </Button>
            </div>
        </>
    );
}
